import { tx } from '@transifex/native'

/* supported locales */
export type TLocales = 'en' | 'da'

tx.init({
  token: process.env.REACT_APP_TRANSIFEX_TOKEN,
})
